import React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    DeviceSourceSet,
    RenderOptimizedVariants,
} from 'src/domains/layouts/webview/components/common/lazyLoadingImage/common/ImagePictureHelpers';
import { LazyLoadingImageRawPropsType } from 'src/domains/layouts/webview/components/common/lazyLoadingImage/common/LazyLoadingImageRaw.type';
import { LazyLoadingImageRaw } from 'src/domains/layouts/webview/components/common/lazyLoadingImage/common/LazyLoadingImageRaw';
import { ImageWrapper, Image } from 'src/domains/layouts/webview/components/common/lazyLoadingImage/LazyImage.style';
import { LazyImageLoadState } from 'src/domains/layouts/state/lazyImageState/LazyImagesState';

export const LazyImage = observer('LazyImage', (props: LazyLoadingImageRawPropsType) => {
    const { alt, className, imgFit, imgBase, imgDeviceSet, onClick, placeholder, dataTest } = props;
    const [state] = React.useState(() => new LazyImageLoadState(imgBase.src));

    if (placeholder === true) {
        return (
            <ImageWrapper
                className={className}
                isLoaded={state.allowShow}
                onClick={onClick}
                data-test={dataTest}
            >
                <picture>
                    <DeviceSourceSet imgDeviceSet={imgDeviceSet} />
                    <RenderOptimizedVariants
                        img={imgBase}
                        formats={['avif', 'webp']}
                    />
                    <Image
                        allowShow={state.allowShow}
                        alt={alt}
                        decoding='async'
                        imgFit={imgFit}
                        loading='lazy'
                        onLoad={state.onLoad}
                        src={imgBase.src}
                        isPlaceholder={placeholder}
                    />
                </picture>
            </ImageWrapper>
        );
    }

    return (
        <LazyLoadingImageRaw
            onClick={onClick}
            dataTest={dataTest}
            alt={alt}
            className={className}
            imgBase={imgBase}
            imgDeviceSet={imgDeviceSet}
            imgFit={imgFit}
        />
    );
});
